import { YStack, XStack, Text } from 'tamagui'
import { HeroIcon } from '@components/HeroIcon'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { mediaDuration } from '@utils/mediaDurationFormatter'

interface ILessonStatusStyles {
  icon: string[]
  color: string
  label: string
}

interface ILessonFooterProps {
  title: string
  showTitle?: boolean
  displayLessonStatus: boolean
  lessonStatusStyles: ILessonStatusStyles
  duration: number | null | undefined
  examQuestionsCount: number | null | undefined
}

export function LessonFooter({
  title,
  showTitle = true,
  displayLessonStatus,
  lessonStatusStyles,
  duration,
  examQuestionsCount,
}: ILessonFooterProps) {
  return (
    <YStack marginTop={12}>
      {showTitle && (
        <Text
          color="$text-primary"
          numberOfLines={1}
          fontSize="$font-size-xs"
          ff="$mulishSemiBold"
          paddingBottom={8}
        >
          {title}
        </Text>
      )}
      <XStack alignItems="center">
        {displayLessonStatus ? (
          <>
            <HeroIcon
              icon={lessonStatusStyles.icon as IconProp}
              color={lessonStatusStyles.color}
              size={16}
            />
            <Text
              marginLeft={4}
              color="$text-primary"
              fontSize="$font-size-xxxs"
              ff="$mulishRegular"
            >
              {lessonStatusStyles.label}
            </Text>
          </>
        ) : duration ? (
          <XStack
            paddingHorizontal={8}
            paddingVertical={4}
            backgroundColor="$bg-surface-sunken"
            borderRadius={4}
          >
            <Text
              ff="$mulishRegular"
              color="$text-primary"
              fontSize="$font-size-xxs"
            >
              {mediaDuration(duration)}
            </Text>
          </XStack>
        ) : examQuestionsCount ? (
          <XStack
            paddingHorizontal={8}
            paddingVertical={4}
            backgroundColor="$bg-surface-sunken"
            borderRadius={4}
          >
            <Text
              ff="$mulishRegular"
              color="$text-primary"
              fontSize="$font-size-xxs"
            >
              {examQuestionsCount}
              {' questões'}
            </Text>
          </XStack>
        ) : null}
      </XStack>
    </YStack>
  )
}
